export const ConfirmTipSvg = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0C4.9 0 0 4.9 0 11C0 17.1 4.9 22 11 22C17.1 22 22 17.1 22 11C22 4.9 17.1 0 11 0ZM12 11V17H10V11H9V9H11C11.6 9 12 9.4 12 10V11ZM10.5 7C9.7 7 9 6.3 9 5.5C9 4.7 9.7 4 10.5 4C11.3 4 12 4.7 12 5.5C12 6.3 11.3 7 10.5 7Z"
      fill="#0051FF"
    />
  </svg>
);
